import React from 'react';
import { styled } from 'styled-components';
import { Tabs, Tooltip } from '@bynder/design-system';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';

type Props = {
    tabs: { value: string; label: string }[];
    activeTab: string;
    onChange: (value: string) => void;
};

const SettingsTabs = ({ tabs, activeTab, onChange }: Props) => (
    <StyledTabs data-testid="settings_tabs">
        {tabs.map((tab) => {
            const tabComponent = (
                <Tabs.Tab
                    key={tab.value}
                    label={tab.label}
                    isActive={tab.value === activeTab}
                    onClick={(e) => {
                        e.preventDefault();
                        onChange(tab.value);
                    }}
                />
            );

            return tab.value.includes('animation') ? (
                <Tooltip key={tab.value} content={`Animations tab (${parseShortcutForTooltip(['shift', 'a'])})`}>
                    {tabComponent}
                </Tooltip>
            ) : (
                tabComponent
            );
        })}
    </StyledTabs>
);

export default SettingsTabs;

const StyledTabs = styled(Tabs)`
    display: flex;
    justify-content: space-evenly;

    & > div {
        min-width: 50%;
        & > button {
            width: 100%;
        }
    }
`;
